import React, { CSSProperties } from 'react';
import { Button } from '../button';
import { Stack } from '../stack';
import { Text } from '../text';
import { ClipIcon } from '../../icons';
import { Element } from '../../primitives';
import { merge } from '../../utils';
import { Interpolation } from '@emotion/react';

interface ICartCounterProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  count?: number;
  text?: string;
  css?: Interpolation<any>;
}

const styles = {
  counterButton: {
    position: ['fixed', 'relative', 'relative'],
    top: ['85vh', '0', '0'],
    left: ['80vw', '0', '0'],
    color: 'white',
    borderRadius: [10, 6, 6],
    height: ['60px', '32px', '32px'],
    width: ['60px', 'auto', 'auto']
  } as Interpolation<any>
};

export const CartCounter: React.FC<ICartCounterProps> = ({ count = 0, text = 'items', css, ...props }) => {
  return (
    <Button
      css={merge(
        styles.counterButton,
        { backgroundColor: count > 0 ? 'cartCounter.nonempty' : 'cartCounter.empty' },
        css
      )}
      {...props}
    >
      <Element as="span" css={{ display: ['none', 'block', 'block'], padding: '0px 8px' }}>
        <ClipIcon />
      </Element>
      <Element
        as="span"
        css={{
          display: ['none', 'block', 'block'],
          border: '1px solid white',
          height: '26px'
        }}
      ></Element>
      <Stack
        as="span"
        css={{
          lineHeight: 'initial',
          alignItems: 'center'
        }}
        direction={['vertical', 'horizontal', 'horizontal']}
      >
        <Text color="white" size="6" css={{ paddingX: '1' }}>
          {count}
        </Text>
        <Text color="white" size={[2, 4, 4]}>
          {text}
        </Text>
      </Stack>
    </Button>
  );
};
